/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { RequestType } from '../Utility/RequestType';

/**
 * Convenient data class for wrapping server connection settings.
 */
export default class ServerSettings
{
    /** The host name for the server. */
    public HostName: string = "";
    /** The port to connect to. */
    public Port: number = 3000;
    /** This game's ID on the server. */
    public GameId: string = "";
    /** The request type, for RGS this should always be POST. */
    public RequestType: RequestType = RequestType.POST;

    public constructor(hostname: string, port: number, gameId: string)
    {
        this.HostName = hostname;
        this.Port = port;
        this.GameId = gameId;
    }
}
